import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class RotationOrigin extends AStringEnum
{
    public static LEFT_TOP = new AString('left top');
    public static LEFT_CENTER = new AString('left center');
    public static LEFT_BOTTOM = new AString('left bottom');

    public static CENTER_TOP = new AString('center top');
    public static CENTER_CENTER = new AString('center center');
    public static CENTER_BOTTOM = new AString('center bottom');

    public static RIGHT_TOP = new AString('right top');
    public static RIGHT_CENTER = new AString('right center');
    public static RIGHT_BOTTOM = new AString('right bottom');

    public static types:Array<AString> = [
        RotationOrigin.LEFT_TOP,
        RotationOrigin.LEFT_CENTER,
        RotationOrigin.LEFT_BOTTOM,

        RotationOrigin.CENTER_TOP,
        RotationOrigin.CENTER_CENTER,
        RotationOrigin.CENTER_BOTTOM,

        RotationOrigin.RIGHT_TOP,
        RotationOrigin.RIGHT_CENTER,
        RotationOrigin.RIGHT_BOTTOM,
    ];

    public constructor(value:AString)
    {
        super(value, RotationOrigin.types);
    }

    public static leftTop():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.LEFT_TOP);
    }

    public static centerTop():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.CENTER_TOP);
    }

    public static rightTop():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.RIGHT_TOP);
    }

    public static leftCenter():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.LEFT_CENTER);
    }

    public static centerCenter():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.CENTER_CENTER);
    }

    public static rightCenter():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.RIGHT_CENTER);
    }

    public static leftBottom():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.LEFT_BOTTOM);
    }

    public static centerBottom():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.CENTER_BOTTOM);
    }

    public static rightBottom():RotationOrigin
    {
        return new RotationOrigin(RotationOrigin.RIGHT_BOTTOM);
    }

}
